<template>
  <div>
    <!-- <div style="-webkit-filter: grayscale(100%);filter: grayscale(100%);"> -->
    <section class="header">
      <header1></header1>
    </section>

    <van-swipe
      class="my-swipe"
      :autoplay="1000000"
      style="height: 200px"
      indicator-color="white"
      v-if="headline.length > 0"
    >
      <van-swipe-item v-for="(item, k) in headline" :key="k">
        <div class="thumb" @click="goThumb(item.id)">
          <van-image :src="item.titleImgUrl"></van-image>
          <div class="title">{{ item.title }}</div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div>
      <div class="main" v-if="hottalk.length && cid == '1000211'">
        <div class="jingxuan">
          <div class="titles">
            <!-- <i class="iconfont icon-jingxuan"></i>  -->
            <svg
              t="1637114280460"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="13925"
              width="15"
              height="15"
            >
              <path
                d="M754.272 433.696 497.92 689.92C489.184 698.912 476.864 704 463.968 704 451.04 704 438.72 698.912 429.984 689.92L269.728 529.792C251.424 510.432 251.424 481.184 269.728 461.824 278.144 453.472 289.664 448.544 301.856 448.128 315.36 447.52 328.48 452.512 337.728 461.824L463.968 588 686.304 365.792C695.168 356.992 707.456 352 720.288 352 733.152 352 745.408 356.992 754.272 365.792 772.576 385.12 772.576 414.368 754.272 433.696M895.872 0 128.128 0C57.248 0 0 57.376 0 128.16L0 895.872C0 966.752 57.376 1024 128.128 1024L895.872 1024C966.752 1024 1024 966.656 1024 895.872L1024 128.16C1024 57.248 966.624 0 895.872 0"
                p-id="13926"
                fill="#d41901"
              ></path>
            </svg>
            关注
          </div>
          <div class="topNew">
            <div v-swiper:mySwiper="swiperOptions">
              <div class="swiper-wrapper">
                <div
                  @click="goView(i.id, i.type)"
                  class="swiper-slide"
                  v-for="(i, k) in hottalk"
                  :key="k"
                >
                  <div class="item">
                    <div class="contents">
                      <div class="subject">
                        {{ i.title }}
                      </div>
                      <div class="simple-desc">
                        {{ i.summary }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <news
        :newList="newList"
        :malaList="malaList"
        :showMalaList="showMalaList"
      ></news>
      <div class="loading" v-if="loadingC">
        <van-loading type="circular" color="#999" />
      </div>
      <infinite-loading @infinite="infiniteHandler" v-if="page > 1">
        <span slot="no-more" style="font-size:10px;">没有内容了。</span>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import header1 from "@/components/header4";
import news from "@/components/news";
import { directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { getList, getTonglan } from "../commJs/api";
import InfiniteLoading from "vue-infinite-loading";
import axios from "axios";
export default {
  components: {
    header1,
    news,
    InfiniteLoading,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      page: 1,
      newList: [],
      cid: 1000211,
      current: 0,
      headline: [],
      loadingC: false,
      jingxuan: [],
      malaList: [],
      hottalk: [],
      swiperOptions: {
        slidesPerView: "auto",
        loop: false,
        spaceBetween: 10,
      },
      showMalaList: false,
      lastId: 0,
    };
  },
  mounted() {
    // Tonglan()
    let cid = this.$route.params.id,
      _this = this;
    this.getIndex(cid);
    _this.malaList = [];
    _this.showMalaList = false;
    axios
      .get("https://www.mala.cn/plugin.php?id=hocks:toutiao", {})
      .then((res) => {
        if (res.data.code == 200) {
          _this.malaList = res.data.list;
        }
      });
    if (cid == "1000211") {
      _this.showMalaList = true;
    }
  },
  watch: {
    $route: function () {
      let cid = this.$route.params.id;
      this.getIndex(cid);
    },
  },
  methods: {
    // Tonglan(){
    //
    // },
    goView(id, t) {
      if (t == 1 || t == 3) {
        this.$router.push({ name: "detail", params: { id: id } });
      } else if (t == 4) {
        this.$router.push({ name: "live", params: { id: id } });
      } else if (t == 2) {
        this.$router.push({ name: "special", params: { id: id } });
      } else {
        this.$router.push({ name: "detail", params: { id: id } });
      }
    },
    goThumb(id) {
      this.$router.push({ name: "detail", params: { id: id } });
    },
    onChange(index) {
      this.current = index;
    },
    dateFormat(val) {
      if (val != null) {
        var date = new Date(val);
        return (
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate()
        );
      }
    },

    infiniteHandler($state) {
      let _this = this;
      getList({
        channelId: this.cid,
        count: 20,
        page: parseInt(this.page),
      }).then((res) => {
        if (res.code == 200) {
          if (!res.data) {
            $state.complete();
          } else {
            this.page = this.page + 1;
            if (this.lastId !== res.data.newsList[0].id) {
              _this.newList = _this.newList.concat(res.data.newsList);
              this.lastId = res.data.newsList[0].id;
              $state.loaded();
            } else {
              $state.complete();
            }
          }
        }
      });
    },
    getDateDiff(date) {
      var result = this.dateFormat(new Date(date).getTime());
      return result;
    },
    getIndex(cid) {
      let _this = this;
      if (cid) this.cid = cid;
      _this.newList = "";
      this.page = 1;
      this.headline = [];
      _this.loadingC = true;
      getTonglan({ channelId: this.cid, count: 20 }).then((res) => {
        if (res.code == 200) {
          _this.headline = res.data.headline;
        }
      });
      getList({ channelId: this.cid, count: 20 }).then((res) => {
        if (res.code == 200) {
          this.page = this.page + 1;
          _this.loadingC = false;
          for (let i in res.data.newsList) {
            if (res.data.newsList[i].isTop === 1) {
              res.data.newsList.splice(i, 1);
            }
          }
          if (cid == "1000211") {
            _this.showMalaList = true;
            _this.hottalk = res.data.newsList.slice(0, 3);
            _this.newList = res.data.newsList.slice(3);
          } else {
            _this.showMalaList = false;
            _this.newList = res.data.newsList;
          }
        }
      });
    },
  },
};
</script>
<style lang="less">
.swiper-slide {
  width: 70% !important;
  //margin-right:20px;
  background: #fff;

  .item {
    min-height: 3rem;
    margin-bottom: 4px;
    padding-bottom: 10px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  }
}
.swiper-wrapper {
  margin: 0 10px;
}

.thumb .van-image {
  img {
    object-fit: cover;
  }
}
</style>
<style scoped lang="less">
.newsList {
  padding: 10px 15px;

  .labletitle {
    // font-family: caoshu1;
    font-size: 18px;
    color: #323953;
  }
}

.fullthumb {
  line-height: 0;
  display: none;
}

.main {
  .jingxuan {
    .titles {
      // font-family: caoshu;
      font-size: 18px;
      //font-weight: bold;
      color: #e92129;
      padding: 8px 15px;
    }

    .iconfont {
      color: #e5444b;
    }
  }
}

.topNew {
  .subject {
    font-size: 14px;
    font-weight: bold;
    color: #323953;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: 10px;
    overflow: hidden;
  }

  .contents {
    padding: 7px 15px;
  }

  .simple-desc {
    font-size: 14px;
    color: #999;
    //padding: 5px 15px;
    margin-top: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  img {
    object-fit: cover;
  }
}

.my-swipe {
  padding: 10px 10px 0 10px;
  width: calc(100% - 20px);
  overflow: hidden;
}

.my-swipe .thumb {
  position: relative;
  height: 200px;
  width: calc(100% - 20px);
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 80px;
    left: 0;
    bottom: 0;
    background-color: transparent;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(transparent),
      to(#000)
    );
    background: -webkit-linear-gradient(top, transparent, #000);
    background: -moz-linear-gradient(top, transparent, #000);
    background: -ms-linear-gradient(top, transparent, #000);
    opacity: 0.6;
  }

  .title {
    color: #fff;
    position: absolute;
    bottom: 20px;
    z-index: 1111;
    left: 10px;
    font-size: 18px;
    width: calc(100 - 20px);
  }
}

.cards {
  .thumb {
    margin: 0;
    padding: 0;
    line-height: 0;
  }

  .content {
    padding: 15px;

    .subject {
      color: rgb(21 73 154);
      font-size: 18px;
      font-weight: 700;
    }

    .simple-desc {
      margin: 10px 0;
      color: #999;
      font-size: 14px;
    }
  }
}
</style>
